export const addImageIntoContainer = (
  file: File,
  dimensions?: { width: number; height: number },
): Promise<File> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const TARGET_WIDTH = dimensions?.width ?? 720;
        const TARGET_HEIGHT = dimensions?.height ?? 240;
        canvas.width = TARGET_WIDTH;
        canvas.height = TARGET_HEIGHT;

        if (ctx) {
          // Mantém o canal alpha (transparência) limpo
          ctx.clearRect(0, 0, TARGET_WIDTH, TARGET_HEIGHT);

          // Lógica de Redimensionamento vs Tamanho Original
          let drawWidth = img.width;
          let drawHeight = img.height;

          // Se a imagem for maior que o container em qualquer dimensão, calculamos a escala
          if (img.width > TARGET_WIDTH || img.height > TARGET_HEIGHT) {
            const scale = Math.min(TARGET_WIDTH / img.width, TARGET_HEIGHT / img.height);
            drawWidth = img.width * scale;
            drawHeight = img.height * scale;
          }

          // Posicionamento dentro do container
          const x = 0; // esquerda alinhada
          const y = (TARGET_HEIGHT - drawHeight) / 2; // centralizado horizontalmente

          ctx.drawImage(img, x, y, drawWidth, drawHeight);
        }

        canvas.toBlob((blob) => {
          if (blob) {
            resolve(new File([blob], file.name, { type: 'image/png' }));
          }
        }, 'image/png');
      };
      img.src = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  });
};
